import React from "react"
import nl2br from "../../../utils/nl2br"
import RetinaImageWrapper from "../../../components/RetinaImage"

export default ({ data = {}, isHq = false }) => {
  if (!data.spaceContact) {
    return null
  }
  return (
    <div className="container">
      <div className={`space-profile-manager bottom-line`}>
        <div className="row">
          <div className="col-md-12">
            <h2>{data.contactSectionTitle}</h2>
          </div>
          <div className="col-lg-8 col-xl-6 pr-0 d-xl-flex">
            <div className="manager-box d-xl-flex">
              <RetinaImageWrapper
                image={data.spaceContact[0].scImage[0]}
                retinaImage={data.spaceContact[0].scImageRetina[0]}
              />
              <div className="text">
                <h5>{data.spaceContact[0].scName}</h5>
                <span>{data.spaceContact[0].scDesignation}</span>
                <p>{nl2br(data.spaceContact[0].scDescription)}</p>
              </div>
            </div>
          </div>
          {!isHq && data.spaceContact[1] && (
            <div className="col-lg-8 col-xl-6 pr-0 d-xl-flex">
              <div className="manager-box d-xl-flex">
                <RetinaImageWrapper
                  image={data.spaceContact[1].scImage[0]}
                  retinaImage={data.spaceContact[1].scImageRetina[0]}
                />
                <div className="text">
                  <h5>{data.spaceContact[1].scName}</h5>
                  <span>{data.spaceContact[1].scDesignation}</span>
                  <p>{nl2br(data.spaceContact[1].scDescription)}</p>
                </div>
              </div>
            </div>
          )}
          {isHq &&
            data.hqSuitesContactSectionTitle &&
            data.additionalItemsTitle &&
            data.additionalItemsText && (
              <div className="col-lg-8 col-xl-6 pl-xl-0 d-xl-flex pr-md-0">
                <div className="manager-box hq-suites d-xl-flex">
                  <div className="text ms-0">
                    <h5>{data.additionalItemsTitle}</h5>
                    <ul className="hq-suites-amenities">
                      {data.additionalItemsText.split("\n").map((text, idx) => (
                        <li key={idx}>{text}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            )}
        </div>
      </div>
    </div>
  )
}
